import { createColumnHelper } from '@tanstack/react-table';
import { CheckIcon } from '#assets/ReactSvg.ts';
import { Pill } from '#components/atoms/pill/Pill.tsx';
import { Table } from '#components/patterns/table/Table.tsx';
import type { DomainListItem } from '#dn-types/domain.ts';
import { DomainActionMenu } from './DomainActionMenu.tsx';
import styles from './DomainTable.module.css';

type Props = {
  data: DomainListItem[];
};

const columnHelper = createColumnHelper<DomainListItem>();

const columns = [
  columnHelper.accessor('domainName', {
    header: 'Domain name',
    cell(info) {
      const { domainName, isVerified } = info.row.original;
      return (
        <div className="flex">
          {domainName}{' '}
          {isVerified ?
            <Pill variant="success" Icon={CheckIcon} className="ml-8">
              Verified
            </Pill>
          : null}
        </div>
      );
    },
  }),
  columnHelper.display({
    id: 'action-menu',
    header: '',
    size: 34,
    cell(info) {
      const { id, domainName, isVerified } = info.row.original;
      return (
        <div className="flex justify-end">
          <DomainActionMenu domainId={id} isVerified={isVerified} domainName={domainName} />
        </div>
      );
    },
  }),
];

export function DomainTable({ data }: Props) {
  return <Table className={styles.DomainTable} data={data} columns={columns} />;
}
